module.exports = __webpack_public_path__ + "teqbahn-assets/media/BlackonTransparent.39bcba61.png";